﻿// @ts-nocheck
// projects + clients CRUD

function currentWorkflowTerms() {
  const isServiceBased = currentBillingModel() === "service_based";
  return {
    isServiceBased,
    clientSingular: isServiceBased ? "customer" : "client",
    clientPlural: isServiceBased ? "customers" : "clients",
    clientTitle: isServiceBased ? "Customer" : "Client",
    clientTitlePlural: isServiceBased ? "Customers" : "Clients",
    projectSingular: isServiceBased ? "service" : "project",
    projectPlural: isServiceBased ? "services" : "projects",
    projectTitle: isServiceBased ? "Service" : "Project",
    projectTitlePlural: isServiceBased ? "Services" : "Projects",
    useProjectAction: isServiceBased ? "Use Service" : "Use Project",
    rateLabel: isServiceBased ? "Default price / rate" : "Rate",
    rateValueSuffix: isServiceBased ? "default" : "/hr",
  };
}

// ========== Projects Management ==========
async function loadProjects() {
  try {
    const res = await fetchWithAuth("/api/projects-meta");
    if (!res.ok) throw new Error("Failed to load projects");
    const payload = await res.json();
    projects = Array.isArray(payload) ? payload : (payload.projects || []);
    renderProjectsList();
    renderProjectSelect();
    updateManualProjectSelect();
    if (typeof renderServiceDashboardOverview === "function") renderServiceDashboardOverview();
  } catch (err) {
    console.error(err);
    const projectsList = document.getElementById("projectsList");
    if (projectsList) projectsList.innerHTML = "<p class='small-text'>Error loading projects.</p>";
  }
}

function renderProjectsList() {
  const projectsList = document.getElementById("projectsList");
  if (!projectsList) return;
  const terms = currentWorkflowTerms();

  if (projects.length === 0) {
    projectsList.innerHTML = `<p class='small-text'>No ${terms.projectPlural} yet. Create one above.</p>`;
    return;
  }

  projectsList.innerHTML = projects.map((p) => {
    const statusClass = (p.status || "active") === 'active' ? 'success' : 'warning';
    const projectName = p.name || `Untitled ${terms.projectTitle}`;
    const clientName = p.clientName || `No ${terms.clientTitle}`;
    const clientState = p.clientState || "";
    const clientEmail = p.clientEmail || "";
    const clientPhone = p.clientPhone || "";
    const clientAddress = p.clientAddress || "";
    const rate = p.defaultRate || 180;
    const notes = p.notes || "";
    const status = p.status || "active";

    return `
      <div class="project-card" id="project-card-${p.id}">
        <!-- VIEW MODE -->
        <div class="project-view" id="project-view-${p.id}" onclick="selectProject('${p.id}')">
          <div class="project-card-header">
            <div style="flex: 1;">
              <div class="project-card-title">${escapeHtml(projectName)}</div>
              <div class="project-card-client">${escapeHtml(clientName)}${clientState ? ` · ${escapeHtml(clientState)}` : ""}</div>
            </div>
            <span class="badge badge-${statusClass}">${escapeHtml(status)}</span>
          </div>

          <div class="project-card-stats">
            <div class="stat-mini">
              <div class="stat-mini-label">${terms.rateLabel}</div>
              <div class="stat-mini-value">$${rate}${terms.rateValueSuffix}</div>
            </div>
          </div>

          ${notes ? `<div class="project-card-notes">${escapeHtml(notes)}</div>` : ''}

          ${(clientEmail || clientPhone || clientAddress) ? `<div class="project-card-contact small-text" style="margin-top:0.5rem; display:flex; flex-wrap:wrap; gap:0.75rem;">
            ${clientEmail ? `<a href="mailto:${escapeHtmlAttr(clientEmail)}" onclick="event.stopPropagation()">✉ ${escapeHtml(clientEmail)}</a>` : ''}
            ${clientPhone ? `<a href="tel:${escapeHtmlAttr(clientPhone.replace(/[^+0-9]/g,''))}" onclick="event.stopPropagation()">☎ ${escapeHtml(clientPhone)}</a>` : ''}
            ${clientAddress ? `<span>Ⓜ ${escapeHtml(clientAddress)}</span>` : ''}
          </div>` : ''}

          <div class="project-card-actions">
            <button class="btn btn-sm btn-primary" onclick="event.stopPropagation(); selectProject('${p.id}')">${terms.useProjectAction}</button>
            <button class="btn btn-sm btn-secondary" data-perm="write" onclick="event.stopPropagation(); editProject('${p.id}')">Edit</button>
            <button class="btn btn-sm btn-danger" data-perm="write" onclick="event.stopPropagation(); deleteProject('${p.id}')">Remove</button>
          </div>
        </div>

        <!-- EDIT MODE (hidden by default) -->
        <div class="project-edit" id="project-edit-${p.id}" style="display:none;" onclick="event.stopPropagation()">
          <div class="project-edit-grid">
            <div class="form-group">
              <label>${terms.projectTitle} name</label>
              <input type="text" id="edit-name-${p.id}" value="${escapeHtmlAttr(projectName)}" />
            </div>
            <div class="form-group">
              <label>${terms.clientTitle}</label>
              <select id="edit-clientid-${p.id}">
                ${clients.map((c) => `<option value="${escapeHtmlAttr(c.id)}"${c.id === p.clientId ? ' selected' : ''}>${escapeHtml(c.name)}</option>`).join('')}
              </select>
              <p class="small-text" style="margin-top: 0.25rem;">Edit contact info in the <a href="#" onclick="event.preventDefault(); selectTab('clients');">${terms.clientTitlePlural}</a> tab.</p>
            </div>
            <div class="form-group">
              <label>${terms.isServiceBased ? "Default price / rate" : "Rate ($/hr)"}</label>
              <input type="number" id="edit-rate-${p.id}" value="${rate}" min="0" step="0.01" />
            </div>
            <div class="form-group">
              <label>Status</label>
              <select id="edit-status-${p.id}">
                <option value="active"${status === 'active' ? ' selected' : ''}>Active</option>
                <option value="paused"${status === 'paused' ? ' selected' : ''}>Paused</option>
                <option value="completed"${status === 'completed' ? ' selected' : ''}>Completed</option>
                <option value="archived"${status === 'archived' ? ' selected' : ''}>Archived</option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <label>Notes</label>
            <textarea id="edit-notes-${p.id}" rows="2">${escapeHtml(notes)}</textarea>
          </div>
          <div class="project-card-actions">
            <button class="btn btn-sm btn-primary" onclick="saveProjectEdit('${p.id}')">Save Changes</button>
            <button class="btn btn-sm btn-secondary" onclick="cancelEditProject('${p.id}')">Cancel</button>
          </div>
        </div>
      </div>
    `;
  }).join('');
}

function renderProjectSelect() {
  const projectSelect = document.getElementById("projectSelect");
  if (!projectSelect) return;
  const terms = currentWorkflowTerms();

  projectSelect.innerHTML = `<option value="">– Select ${terms.projectSingular} –</option>` + 
    projects.map((p) => `<option value="${p.id}">${p.name} (${p.clientName})</option>`).join('');
}

function updateManualProjectSelect() {
  const manualProjectSelect = document.getElementById("manualProjectSelect");
  if (!manualProjectSelect) return;
  const terms = currentWorkflowTerms();

  manualProjectSelect.innerHTML = `<option value="">– Select ${terms.projectSingular} –</option>` + 
    projects.map((p) => `<option value="${p.id}">${p.name}</option>`).join('');
}

function selectProject(projectId) {
  const projectSelect = document.getElementById("projectSelect");
  if (projectSelect) projectSelect.value = projectId;
}

async function addProject() {
  const terms = currentWorkflowTerms();
  const name = document.getElementById("newProjectName").value.trim();
  const clientId = (document.getElementById("newProjectClientSelect")?.value || "").trim();
  const rate = parseFloat(document.getElementById("newDefaultRate").value) || 180;
  const notes = document.getElementById("newNotes").value.trim();

  if (!name) {
    alert(`${terms.projectTitle} name is required.`);
    return;
  }
  if (!clientId) {
    alert(`Please select a ${terms.clientSingular} (or add one in the ${terms.clientTitlePlural} tab).`);
    return;
  }

  try {
    const res = await fetchWithAuth("/api/projects-meta", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name,
        clientId,
        defaultRate: rate,
        notes: notes || "",
        status: "active",
      }),
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || `Failed to add ${terms.projectSingular}`);
    }

    document.getElementById("newProjectName").value = "";
    const sel = document.getElementById("newProjectClientSelect");
    if (sel) sel.value = "";
    document.getElementById("newDefaultRate").value = "180";
    document.getElementById("newNotes").value = "";

    await loadProjects();
  } catch (err) {
    console.error(err);
    alert(`Error adding ${terms.projectSingular}: ` + err.message);
  }
}

// ========== Clients (top-level contacts) ==========
async function loadClients() {
  try {
    const res = await fetchWithAuth("/api/clients");
    if (!res.ok) throw new Error("Failed to load clients");
    const payload = await res.json();
    clients = Array.isArray(payload) ? payload : (payload.clients || []);
    renderClientsList();
    renderClientPicker();
    if (typeof renderServiceDashboardOverview === "function") renderServiceDashboardOverview();
  } catch (err) {
    console.error(err);
    const list = document.getElementById("clientsList");
    if (list) list.innerHTML = "<p class='small-text'>Error loading clients.</p>";
  }
}

function renderClientPicker() {
  const sel = document.getElementById("newProjectClientSelect");
  if (!sel) return;
  const terms = currentWorkflowTerms();
  const current = sel.value;
  sel.innerHTML = `<option value="">— Select a ${terms.clientSingular} —</option>`
    + clients.map((c) => `<option value="${escapeHtmlAttr(c.id)}">${escapeHtml(c.name)}${c.email ? ' · ' + escapeHtml(c.email) : ''}</option>`).join('');
  if (current) sel.value = current;
}

function renderClientsList() {
  const list = document.getElementById("clientsList");
  if (!list) return;
  const terms = currentWorkflowTerms();
  if (clients.length === 0) {
    list.innerHTML = `<p class='small-text'>No ${terms.clientPlural} yet. Add one above.</p>`;
    return;
  }
  list.innerHTML = clients.map((c) => {
    const projectsForClient = projects.filter((p) => p.clientId === c.id);
    return `
      <div class="client-card project-card" id="client-card-${c.id}">
        <div class="client-view" id="client-view-${c.id}">
          <div class="project-card-header">
            <div style="flex:1;">
              <div class="project-card-title">${escapeHtml(c.name || `Unnamed ${terms.clientTitle}`)}</div>
              <div class="project-card-client">${projectsForClient.length} ${projectsForClient.length === 1 ? terms.projectSingular : terms.projectPlural}${c.state ? ' · ' + escapeHtml(c.state) : ''}</div>
            </div>
          </div>
          <div class="project-card-contact small-text" style="margin-top:0.5rem; display:flex; flex-wrap:wrap; gap:0.75rem;">
            ${c.email ? `<a href="mailto:${escapeHtmlAttr(c.email)}">✉ ${escapeHtml(c.email)}</a>` : ''}
            ${c.phone ? `<a href="tel:${escapeHtmlAttr((c.phone || '').replace(/[^+0-9]/g,''))}">☎ ${escapeHtml(c.phone)}</a>` : ''}
            ${c.address ? `<span>📍 ${escapeHtml(c.address)}</span>` : ''}
          </div>
          ${c.notes ? `<div class="project-card-notes">${escapeHtml(c.notes)}</div>` : ''}
          <div class="project-card-actions" data-perm="write">
            <button class="btn btn-sm btn-secondary" onclick="editClient('${c.id}')">Edit</button>
            <button class="btn btn-sm btn-danger" onclick="deleteClient('${c.id}')">Remove</button>
          </div>
        </div>
        <div class="client-edit" id="client-edit-${c.id}" style="display:none;">
          <div class="project-edit-grid">
            <div class="form-group"><label>Name</label><input type="text" id="cedit-name-${c.id}" value="${escapeHtmlAttr(c.name || '')}" /></div>
            <div class="form-group"><label>Email</label><input type="email" id="cedit-email-${c.id}" value="${escapeHtmlAttr(c.email || '')}" /></div>
            <div class="form-group"><label>Phone</label><input type="tel" id="cedit-phone-${c.id}" value="${escapeHtmlAttr(c.phone || '')}" /></div>
            <div class="form-group"><label>Address</label><input type="text" id="cedit-address-${c.id}" value="${escapeHtmlAttr(c.address || '')}" /></div>
            <div class="form-group"><label>State</label><input type="text" id="cedit-state-${c.id}" value="${escapeHtmlAttr(c.state || '')}" maxlength="2" /></div>
          </div>
          <div class="form-group"><label>Notes</label><textarea id="cedit-notes-${c.id}" rows="2">${escapeHtml(c.notes || '')}</textarea></div>
          <div class="project-card-actions">
            <button class="btn btn-sm btn-primary" onclick="saveClientEdit('${c.id}')">Save</button>
            <button class="btn btn-sm btn-secondary" onclick="cancelEditClient('${c.id}')">Cancel</button>
          </div>
        </div>
      </div>
    `;
  }).join('');
}

async function addClient() {
  const terms = currentWorkflowTerms();
  const name = document.getElementById("newClientName2").value.trim();
  const email = document.getElementById("newClientEmail2").value.trim();
  const phone = document.getElementById("newClientPhone2").value.trim();
  const address = document.getElementById("newClientAddress2").value.trim();
  const stateRaw = document.getElementById("newClientState2").value.trim().toUpperCase();
  const state = /^[A-Z]{2}$/.test(stateRaw) ? stateRaw : "";
  const notes = document.getElementById("newClientNotes2").value.trim();

  if (!name) {
    alert(`${terms.clientTitle} name is required.`);
    return;
  }

  try {
    const res = await fetchWithAuth("/api/clients", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name, email, phone, address, state, notes }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || `Failed to add ${terms.clientSingular}`);
    }
    document.getElementById("newClientName2").value = "";
    document.getElementById("newClientEmail2").value = "";
    document.getElementById("newClientPhone2").value = "";
    document.getElementById("newClientAddress2").value = "";
    document.getElementById("newClientState2").value = "";
    document.getElementById("newClientNotes2").value = "";
    await loadClients();
  } catch (err) {
    console.error(err);
    alert(`Error adding ${terms.clientSingular}: ` + err.message);
  }
}

function editClient(clientId) {
  const view = document.getElementById(`client-view-${clientId}`);
  const edit = document.getElementById(`client-edit-${clientId}`);
  if (view && edit) { view.style.display = "none"; edit.style.display = "block"; }
}

function cancelEditClient(clientId) {
  const view = document.getElementById(`client-view-${clientId}`);
  const edit = document.getElementById(`client-edit-${clientId}`);
  if (view && edit) { view.style.display = ""; edit.style.display = "none"; }
}

async function saveClientEdit(clientId) {
  const terms = currentWorkflowTerms();
  const existing = clients.find((c) => c.id === clientId);
  if (!existing) return alert(`${terms.clientTitle} not found.`);
  const name = (document.getElementById(`cedit-name-${clientId}`)?.value || "").trim();
  const email = (document.getElementById(`cedit-email-${clientId}`)?.value || "").trim();
  const phone = (document.getElementById(`cedit-phone-${clientId}`)?.value || "").trim();
  const address = (document.getElementById(`cedit-address-${clientId}`)?.value || "").trim();
  const stateRaw = (document.getElementById(`cedit-state-${clientId}`)?.value || "").trim().toUpperCase();
  const state = /^[A-Z]{2}$/.test(stateRaw) ? stateRaw : "";
  const notes = (document.getElementById(`cedit-notes-${clientId}`)?.value || "").trim();
  if (!name) return alert(`${terms.clientTitle} name is required.`);
  try {
    const res = await fetchWithAuth("/api/clients", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: clientId, name, email, phone, address, state, notes }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || `Failed to save ${terms.clientSingular}`);
    }
    await loadClients();
    // Projects denormalized snapshots are updated server-side; refresh the list.
    await loadProjects();
  } catch (err) {
    console.error(err);
    alert(`Error saving ${terms.clientSingular}: ` + err.message);
  }
}

async function deleteClient(clientId) {
  const terms = currentWorkflowTerms();
  if (!confirm(`Delete this ${terms.clientSingular}? Their ${terms.projectPlural} must be removed or reassigned first.`)) return;
  try {
    const res = await fetchWithAuth("/api/clients", {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ clientId }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || `Failed to delete ${terms.clientSingular}`);
    }
    await loadClients();
  } catch (err) {
    console.error(err);
    alert(`Error deleting ${terms.clientSingular}: ` + err.message);
  }
}

async function deleteProject(projectId) {
  const terms = currentWorkflowTerms();
  if (!confirm(`Delete this ${terms.projectSingular}? This cannot be undone.`)) return;

  try {
    const res = await fetchWithAuth("/api/projects-meta", {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ projectId }),
    });

    if (!res.ok) {
      const error = await res.json();
      alert(`Error deleting ${terms.projectSingular}: ${error.error || "Unknown error"}`);
      return;
    }

    alert(`${terms.projectTitle} deleted successfully!`);
    await loadProjects();
  } catch (err) {
    console.error("Error deleting project:", err);
    alert(`Error deleting ${terms.projectSingular}. Check console for details.`);
  }
}

// ----- Project inline editing -----
function editProject(projectId) {
  const view = document.getElementById(`project-view-${projectId}`);
  const edit = document.getElementById(`project-edit-${projectId}`);
  if (view && edit) {
    view.style.display = "none";
    edit.style.display = "block";
    const nameInput = document.getElementById(`edit-name-${projectId}`);
    if (nameInput) nameInput.focus();
  }
}

function cancelEditProject(projectId) {
  const view = document.getElementById(`project-view-${projectId}`);
  const edit = document.getElementById(`project-edit-${projectId}`);
  if (view && edit) {
    view.style.display = "";
    edit.style.display = "none";
  }
}

async function saveProjectEdit(projectId) {
  const terms = currentWorkflowTerms();
  const existing = projects.find((p) => p.id === projectId);
  if (!existing) {
    alert(`${terms.projectTitle} not found.`);
    return;
  }

  const name = (document.getElementById(`edit-name-${projectId}`)?.value || "").trim();
  const clientId = (document.getElementById(`edit-clientid-${projectId}`)?.value || "").trim();
  const rate = parseFloat(document.getElementById(`edit-rate-${projectId}`)?.value);
  const status = document.getElementById(`edit-status-${projectId}`)?.value || "active";
  const notes = (document.getElementById(`edit-notes-${projectId}`)?.value || "").trim();

  if (!name) {
    alert(`${terms.projectTitle} name is required.`);
    return;
  }
  if (!clientId) {
    alert(`Please select a ${terms.clientSingular}.`);
    return;
  }
  if (!Number.isFinite(rate) || rate < 0) {
    alert("Rate must be a non-negative number.");
    return;
  }

  const updated = {
    ...existing,
    name,
    clientId,
    defaultRate: rate,
    status,
    notes,
  };

  try {
    const res = await fetchWithAuth("/api/projects-meta", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updated),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      alert(`Error saving ${terms.projectSingular}: ${err.error || res.statusText}`);
      return;
    }
    await loadProjects();
  } catch (err) {
    console.error("Error saving project:", err);
    alert(`Error saving ${terms.projectSingular}. Check console for details.`);
  }
}
